import React from "react";

const SkillCard = ({ title, skills }) => (
  <div className="skill-card">
    <h3 className="mb-4 font-display text-lg font-semibold text-brand-600 dark:text-brand-400">
      {title}
    </h3>
    <ul className="flex flex-wrap gap-2">
      {skills.map((skill, index) => (
        <li
          key={index}
          className="inline-flex items-center gap-2 rounded-xl bg-ink-50 px-3 py-2 text-sm font-medium text-ink-700 ring-1 ring-ink-100 transition-colors hover:bg-brand-50 hover:text-brand-800 hover:ring-brand-200 dark:bg-ink-800 dark:text-ink-200 dark:ring-ink-700 dark:hover:bg-brand-950 dark:hover:text-brand-300 dark:hover:ring-brand-800"
        >
          <img
            src={`images/${skill.icon}`}
            alt=""
            aria-hidden="true"
            className="h-5 w-5 shrink-0 object-contain"
          />
          <span>{skill.name}</span>
        </li>
      ))}
    </ul>
  </div>
);

export default SkillCard;
